import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IEditBehavior } from "../../../../documaker/domain/format/objects";

export interface IEditBehaviorPropertyEditable {
  editBehavior(): IPropertyEditable<IEditBehavior>;
}

export function instanceOfIEditBehaviorPropertyEditable(instance: any): instance is IEditBehaviorPropertyEditable {
  return instance
      && instance.editBehavior
      && instanceOfIPropertyEditable<IEditBehavior>(instance.editBehavior());
}
